import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ElementRef,
} from "@angular/core";
import { LocalizeService } from "../../../../insa-services";

@Component({
  selector: "grid-wizard-row",
  styles: [
    `
      .wizard-box {
        height: 400px;
        overflow-y: auto;
        border: 1px solid gray;
      }
      .wizard-item {
        cursor: pointer;
        padding: 0.25em 0.5em;
        background: #fff;
      }

      .wizard-item:nth-child(2n) {
        background: #e8e8e8;
      }

      .wizard-item.current {
        color: #0000ff;
        background: #87cefa;
      }
    `,
  ],
  template: ` <div style="display: flex; flex-direction: row;">
      <div class="grid-wizard-category-header" style="flex-basis: 50%">
        <h4 localize="Res2057">Available</h4>
      </div>
      <div
        style="display: flex; flex-direction: column; flex-basis: 4em; margin: 0 1em; justify-content: center;"
      ></div>
      <div class="grid-wizard-category-header" style="flex-basis: 50%">
        <h4 localize="Res474">Selected</h4>
      </div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex-basis: 50%">
        <div class="wizard-box">
          <ng-container *ngFor="let item of availableItems">
            <div
              *ngIf="item.field"
              [class.current]="
                item && selectedItem && item.field === selectedItem.field
              "
              class="wizard-item"
              (click)="selectedItem = item; selectedGroup = 'availableItems'"
            >
              {{ item.title || item.field }}

              <!-- <div>
                <button
                  [disabled]="selectedGroup !== 'availableItems'"
                  type="button"
                  (click)="moveItemDown(item); $event.stopPropagation()"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2" fill="#F4F4FA" />
                    <path
                      d="M18.138 10.0317L12.6837 15.0311C12.6331 15.0776 12.5729 15.1145 12.5067 15.1396C12.4405 15.1648 12.3695 15.1777 12.2979 15.1777C12.2262 15.1777 12.1552 15.1648 12.089 15.1396C12.0228 15.1145 11.9626 15.0776 11.912 15.0311L6.45769 10.0317C6.35535 9.93786 6.29785 9.81062 6.29785 9.67796C6.29785 9.54529 6.35535 9.41806 6.45769 9.32425C6.56004 9.23044 6.69885 9.17773 6.84358 9.17773C6.98832 9.17773 7.12713 9.23044 7.22947 9.32425L12.2979 13.9706L17.3662 9.32425C17.4169 9.2778 17.4771 9.24095 17.5433 9.21581C17.6095 9.19067 17.6805 9.17773 17.7521 9.17773C17.8238 9.17773 17.8948 9.19067 17.961 9.21581C18.0272 9.24095 18.0873 9.2778 18.138 9.32425C18.1887 9.3707 18.2289 9.42584 18.2563 9.48653C18.2837 9.54722 18.2979 9.61227 18.2979 9.67796C18.2979 9.74365 18.2837 9.80869 18.2563 9.86938C18.2289 9.93007 18.1887 9.98522 18.138 10.0317Z"
                      fill="#2B2B2B"
                    />
                  </svg>
                </button>
                <button
                  [disabled]="selectedGroup !== 'availableItems'"
                  type="button"
                  (click)="moveItemUp(item); $event.stopPropagation()"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2" fill="#F4F4FA" />
                    <path
                      d="M18.1379 15.0311C18.0872 15.0776 18.0271 15.1145 17.9609 15.1396C17.8947 15.1648 17.8237 15.1777 17.752 15.1777C17.6803 15.1777 17.6093 15.1648 17.5431 15.1396C17.4769 15.1145 17.4168 15.0776 17.3661 15.0311L12.2978 10.3848L7.22946 15.0311C7.12712 15.1249 6.98831 15.1776 6.84358 15.1776C6.69884 15.1776 6.56003 15.1249 6.45769 15.0311C6.35535 14.9373 6.29785 14.8101 6.29785 14.6774C6.29785 14.5447 6.35535 14.4175 6.45769 14.3237L11.9119 9.32436C11.9626 9.27788 12.0227 9.241 12.0889 9.21584C12.1551 9.19068 12.2261 9.17773 12.2978 9.17773C12.3695 9.17773 12.4404 9.19068 12.5067 9.21584C12.5729 9.241 12.633 9.27788 12.6837 9.32436L18.1379 14.3237C18.1886 14.3701 18.2288 14.4253 18.2563 14.486C18.2837 14.5467 18.2979 14.6117 18.2979 14.6774C18.2979 14.7431 18.2837 14.8082 18.2563 14.8689C18.2288 14.9295 18.1886 14.9847 18.1379 15.0311Z"
                      fill="#2B2B2B"
                    />
                  </svg>
                </button>
              </div> -->
            </div>
          </ng-container>
        </div>
      </div>
      <div class="wizard-transfer-controls">
        <div>
          <div class="d-flex align-items-center">
            <label localize="Res1137">Move one</label>
            <button
              [disabled]="selectedGroup !== 'availableItems'"
              type="button"
              (click)="showItem()"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.031 12.5306L9.53104 20.0306C9.46136 20.1002 9.37863 20.1555 9.28759 20.1932C9.19654 20.2309 9.09896 20.2503 9.00042 20.2503C8.90187 20.2503 8.80429 20.2309 8.71324 20.1932C8.6222 20.1555 8.53947 20.1002 8.46979 20.0306C8.40011 19.9609 8.34483 19.8781 8.30712 19.7871C8.26941 19.6961 8.25 19.5985 8.25 19.4999C8.25 19.4014 8.26941 19.3038 8.30712 19.2128C8.34483 19.1217 8.40011 19.039 8.46979 18.9693L15.4401 11.9999L8.46979 5.03055C8.32906 4.88982 8.25 4.69895 8.25 4.49993C8.25 4.30091 8.32906 4.11003 8.46979 3.9693C8.61052 3.82857 8.80139 3.74951 9.00042 3.74951C9.19944 3.74951 9.39031 3.82857 9.53104 3.9693L17.031 11.4693C17.1008 11.539 17.1561 11.6217 17.1938 11.7127C17.2316 11.8038 17.251 11.9014 17.251 11.9999C17.251 12.0985 17.2316 12.1961 17.1938 12.2871C17.1561 12.3782 17.1008 12.4609 17.031 12.5306Z"
                  fill="#353574"
                />
              </svg>
            </button>
          </div>
          <div class="d-flex align-items-center">
            <label localize="Res1138">Move all</label>
            <button type="button" (click)="showAllColumns()">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.78104 8.78104L1.28104 16.281C1.14031 16.4218 0.94944 16.5008 0.750417 16.5008C0.551394 16.5008 0.360523 16.4218 0.219792 16.281C0.0790615 16.1403 3.92322e-09 15.9494 0 15.7504C-3.92322e-09 15.5514 0.0790615 15.3605 0.219792 15.2198L7.1901 8.25042L0.219792 1.28104C0.0790615 1.14031 0 0.94944 0 0.750417C0 0.551394 0.0790615 0.360523 0.219792 0.219792C0.360523 0.0790615 0.551394 0 0.750417 0C0.94944 0 1.14031 0.0790615 1.28104 0.219792L8.78104 7.71979C8.85077 7.78945 8.90609 7.87216 8.94384 7.96321C8.98158 8.05426 9.00101 8.15186 9.00101 8.25042C9.00101 8.34898 8.98158 8.44657 8.94384 8.53762C8.90609 8.62867 8.85077 8.71139 8.78104 8.78104ZM16.281 7.71979L8.78104 0.219792C8.64031 0.0790615 8.44944 0 8.25042 0C8.05139 0 7.86052 0.0790615 7.71979 0.219792C7.57906 0.360523 7.5 0.551394 7.5 0.750417C7.5 0.94944 7.57906 1.14031 7.71979 1.28104L14.6901 8.25042L7.71979 15.2198C7.57906 15.3605 7.5 15.5514 7.5 15.7504C7.5 15.9494 7.57906 16.1403 7.71979 16.281C7.86052 16.4218 8.05139 16.5008 8.25042 16.5008C8.44944 16.5008 8.64031 16.4218 8.78104 16.281L16.281 8.78104C16.3508 8.71139 16.4061 8.62867 16.4438 8.53762C16.4816 8.44657 16.501 8.34898 16.501 8.25042C16.501 8.15186 16.4816 8.05426 16.4438 7.96321C16.4061 7.87216 16.3508 7.78945 16.281 7.71979Z"
                  fill="#353574"
                />
              </svg>
            </button>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center">
            <label localize="Res1137">Move one</label>
            <button
              [disabled]="selectedGroup !== 'activeItems'"
              type="button"
              (click)="hideItem()"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5302 18.9693C15.5999 19.039 15.6552 19.1217 15.6929 19.2128C15.7306 19.3038 15.75 19.4014 15.75 19.4999C15.75 19.5985 15.7306 19.6961 15.6929 19.7871C15.6552 19.8781 15.5999 19.9609 15.5302 20.0306C15.4606 20.1002 15.3778 20.1555 15.2868 20.1932C15.1957 20.2309 15.0982 20.2503 14.9996 20.2503C14.9011 20.2503 14.8035 20.2309 14.7124 20.1932C14.6214 20.1555 14.5387 20.1002 14.469 20.0306L6.96899 12.5306C6.89926 12.4609 6.84394 12.3782 6.80619 12.2871C6.76845 12.1961 6.74902 12.0985 6.74902 11.9999C6.74902 11.9014 6.76845 11.8038 6.80619 11.7127C6.84394 11.6217 6.89926 11.539 6.96899 11.4693L14.469 3.9693C14.6097 3.82857 14.8006 3.74951 14.9996 3.74951C15.1986 3.74951 15.3895 3.82857 15.5302 3.9693C15.671 4.11003 15.75 4.30091 15.75 4.49993C15.75 4.69895 15.671 4.88982 15.5302 5.03055L8.55993 11.9999L15.5302 18.9693Z"
                  fill="#353574"
                />
              </svg>
            </button>
          </div>
          <div class="d-flex align-items-center">
            <label localize="Res1138">Move all</label>
            <button type="button" (click)="hideAllColumns()">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.2802 18.9693C19.3499 19.039 19.4052 19.1217 19.4429 19.2128C19.4806 19.3038 19.5 19.4014 19.5 19.4999C19.5 19.5985 19.4806 19.6961 19.4429 19.7871C19.4052 19.8781 19.3499 19.9609 19.2802 20.0306C19.2106 20.1002 19.1278 20.1555 19.0368 20.1932C18.9457 20.2309 18.8482 20.2503 18.7496 20.2503C18.6511 20.2503 18.5535 20.2309 18.4624 20.1932C18.3714 20.1555 18.2887 20.1002 18.219 20.0306L10.719 12.5306C10.6493 12.4609 10.5939 12.3782 10.5562 12.2871C10.5185 12.1961 10.499 12.0985 10.499 11.9999C10.499 11.9014 10.5185 11.8038 10.5562 11.7127C10.5939 11.6217 10.6493 11.539 10.719 11.4693L18.219 3.9693C18.3597 3.82857 18.5506 3.74951 18.7496 3.74951C18.9486 3.74951 19.1395 3.82857 19.2802 3.9693C19.421 4.11003 19.5 4.30091 19.5 4.49993C19.5 4.69895 19.421 4.88982 19.2802 5.03055L12.3099 11.9999L19.2802 18.9693ZM4.80993 11.9999L11.7802 5.03055C11.921 4.88982 12 4.69895 12 4.49993C12 4.30091 11.921 4.11003 11.7802 3.9693C11.6395 3.82857 11.4486 3.74951 11.2496 3.74951C11.0506 3.74951 10.8597 3.82857 10.719 3.9693L3.21899 11.4693C3.14926 11.539 3.09394 11.6217 3.05619 11.7127C3.01845 11.8038 2.99902 11.9014 2.99902 11.9999C2.99902 12.0985 3.01845 12.1961 3.05619 12.2871C3.09394 12.3782 3.14926 12.4609 3.21899 12.5306L10.719 20.0306C10.7887 20.1002 10.8714 20.1555 10.9624 20.1932C11.0535 20.2309 11.1511 20.2503 11.2496 20.2503C11.3482 20.2503 11.4457 20.2309 11.5368 20.1932C11.6278 20.1555 11.7106 20.1002 11.7802 20.0306C11.8499 19.9609 11.9052 19.8781 11.9429 19.7871C11.9806 19.6961 12 19.5985 12 19.4999C12 19.4014 11.9806 19.3038 11.9429 19.2128C11.9052 19.1217 11.8499 19.039 11.7802 18.9693L4.80993 11.9999Z"
                  fill="#353574"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div style="flex-basis: 50%">
        <div class="wizard-box">
          <ng-container *ngFor="let item of activeItems">
            <div
              *ngIf="item.field"
              [class.current]="
                item && selectedItem && item.field === selectedItem.field
              "
              class="wizard-item"
              (click)="selectedItem = item; selectedGroup = 'activeItems'"
            >
              {{ item.title || item.field }}
              <div>
                <button
                  type="button"
                  (click)="moveItemDown(item); $event.stopPropagation()"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2" />
                    <path
                      d="M18.138 10.0317L12.6837 15.0311C12.6331 15.0776 12.5729 15.1145 12.5067 15.1396C12.4405 15.1648 12.3695 15.1777 12.2979 15.1777C12.2262 15.1777 12.1552 15.1648 12.089 15.1396C12.0228 15.1145 11.9626 15.0776 11.912 15.0311L6.45769 10.0317C6.35535 9.93786 6.29785 9.81062 6.29785 9.67796C6.29785 9.54529 6.35535 9.41806 6.45769 9.32425C6.56004 9.23044 6.69885 9.17773 6.84358 9.17773C6.98832 9.17773 7.12713 9.23044 7.22947 9.32425L12.2979 13.9706L17.3662 9.32425C17.4169 9.2778 17.4771 9.24095 17.5433 9.21581C17.6095 9.19067 17.6805 9.17773 17.7521 9.17773C17.8238 9.17773 17.8948 9.19067 17.961 9.21581C18.0272 9.24095 18.0873 9.2778 18.138 9.32425C18.1887 9.3707 18.2289 9.42584 18.2563 9.48653C18.2837 9.54722 18.2979 9.61227 18.2979 9.67796C18.2979 9.74365 18.2837 9.80869 18.2563 9.86938C18.2289 9.93007 18.1887 9.98522 18.138 10.0317Z"
                      fill="#2B2B2B"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  (click)="moveItemUp(item); $event.stopPropagation()"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2" />
                    <path
                      d="M18.1379 15.0311C18.0872 15.0776 18.0271 15.1145 17.9609 15.1396C17.8947 15.1648 17.8237 15.1777 17.752 15.1777C17.6803 15.1777 17.6093 15.1648 17.5431 15.1396C17.4769 15.1145 17.4168 15.0776 17.3661 15.0311L12.2978 10.3848L7.22946 15.0311C7.12712 15.1249 6.98831 15.1776 6.84358 15.1776C6.69884 15.1776 6.56003 15.1249 6.45769 15.0311C6.35535 14.9373 6.29785 14.8101 6.29785 14.6774C6.29785 14.5447 6.35535 14.4175 6.45769 14.3237L11.9119 9.32436C11.9626 9.27788 12.0227 9.241 12.0889 9.21584C12.1551 9.19068 12.2261 9.17773 12.2978 9.17773C12.3695 9.17773 12.4404 9.19068 12.5067 9.21584C12.5729 9.241 12.633 9.27788 12.6837 9.32436L18.1379 14.3237C18.1886 14.3701 18.2288 14.4253 18.2563 14.486C18.2837 14.5467 18.2979 14.6117 18.2979 14.6774C18.2979 14.7431 18.2837 14.8082 18.2563 14.8689C18.2288 14.9295 18.1886 14.9847 18.1379 15.0311Z"
                      fill="#2B2B2B"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>`,
})
export class GridWizardRowComponent implements OnChanges {
  @Input() settings: kendo.ui.GridOptions | any;
  @Input() editMode: "columns" | "groups";
  @Output() onChange = new EventEmitter();

  availableItems;
  activeItems;
  selectedItem;
  selectedGroup: "activeItems" | "availableItems";

  constructor(
    private _localize: LocalizeService,
    private _element: ElementRef,
  ) {}

  ngAfterViewInit() {
    this._localize.applyTranslations(this._element.nativeElement);
  }

  moveItemUp(item?: any) {
    const target = item || this.selectedItem;
    if (!target) return;

    let index: number, itemBeingReplaced;
    index = this.activeItems.indexOf(target);
    itemBeingReplaced = this.activeItems[index - 1];
    if (itemBeingReplaced) {
      const targetArray =
        this.editMode === "columns"
          ? this.settings.columns
          : this.settings.dataSource.group;
      const index1 = targetArray.findIndex((i) => i.field === target.field);
      const index2 = targetArray.findIndex(
        (i) => i.field === itemBeingReplaced.field,
      );
      targetArray[index1] = itemBeingReplaced;
      targetArray[index2] = target;
      this.calcAvailableActiveItems();
      this.onChange.emit();
    }
  }

  moveItemDown(item?: any) {
    const target = item || this.selectedItem;
    if (!target) return;

    let index: number, itemBeingReplaced;
    index = this.activeItems.indexOf(target);
    itemBeingReplaced = this.activeItems[index + 1];
    if (itemBeingReplaced) {
      const targetArray =
        this.editMode === "columns"
          ? this.settings.columns
          : this.settings.dataSource.group;
      const index1 = targetArray.findIndex((i) => i.field === target.field);
      const index2 = targetArray.findIndex(
        (i) => i.field === itemBeingReplaced.field,
      );
      targetArray[index1] = itemBeingReplaced;
      targetArray[index2] = target;
      this.calcAvailableActiveItems();
      this.onChange.emit();
    }
  }

  hideItem() {
    if (this.editMode === "columns") {
      this.selectedItem.hidden = true;
    } else {
      const index = this.settings.dataSource.group.findIndex(
        (g) => g.field === this.selectedItem.field,
      );
      this.settings.dataSource.group.splice(index, 1);
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  showItem() {
    if (this.editMode === "columns") {
      this.selectedItem.hidden = false;
    } else {
      this.settings.dataSource.group.push({
        field: this.selectedItem.field,
      });
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  showAllColumns() {
    if (this.editMode === "columns") {
      this.availableItems.forEach((col) => {
        col.hidden = false;
      });
    } else {
      this.settings.dataSource.group.push(
        ...this.availableItems.map((col) => ({ field: col.field })),
      );
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  hideAllColumns() {
    if (this.editMode === "columns") {
      this.activeItems.forEach((col) => {
        if (col.field) {
          col.hidden = true;
        }
      });
    } else {
      this.settings.dataSource.group = [];
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  calcAvailableActiveItems() {
    if (this.editMode === "columns") {
      this.availableItems = this.settings.columns.filter((col) => col.hidden);
      this.activeItems = this.settings.columns.filter((col) => !col.hidden);
    } else {
      this.availableItems = this.settings.columns.filter(
        (col) =>
          col.groupable &&
          !this.settings.dataSource.group.find((g) => g.field === col.field),
      );
      this.activeItems = this.settings.dataSource.group.map(
        (g) =>
          ({
            ...g,
            title: this.settings.columns.find((col) => col.field === g.field),
          }).title,
      );
    }

    if (this.selectedItem) {
      if (
        this.availableItems.find((col) => col.field === this.selectedItem.field)
      ) {
        this.selectedItem = this.availableItems.find(
          (col) => col.field === this.selectedItem.field,
        );
        this.selectedGroup = "availableItems";
      } else if (
        this.activeItems.find((col) => col.field === this.selectedItem.field)
      ) {
        this.selectedItem = this.activeItems.find(
          (col) => col.field === this.selectedItem.field,
        );
        this.selectedGroup = "activeItems";
      }
    } else {
      this.selectedGroup = null;
    }
  }

  ngOnChanges(changes) {
    if (
      (changes.settings && changes.settings.currentValue) ||
      (changes.editMode && changes.editMode.currentValue)
    ) {
      this.calcAvailableActiveItems();
    }
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-grid/components/grid-wizard-row.component.ts